import { useDispatch, useSelector } from 'react-redux'
// import { WalletIcoIcon } from 'components/ui-kit/Icons/svg/index'
import { useTranslation } from 'react-i18next'
import { getPrecision } from 'utils/helperFunctions.utils'
// import { CRYPTO_COINS } from 'constants/index'
// import { SearchIconIcon } from 'components/ui-kit/Icons/svg/index'
import './CurrencyDropdown.scss'
import { setShowCashierPopup } from 'redux-thunk/redux/slices/settings.slice'
import CashierPopup from '../CashierPopup/index'
import { useState } from 'react'
// import { clutchWalletIcon } from 'components/ui-kit/Icons/png/index'

const CurrencyDropdown = (props) => {
  // const { setShowWalletSetting } = props
  const { t } = useTranslation()
  const {
    selectedWallet
    // user,
    // hideZeroCurrency,
    // displayFiatCurrency,
    // selectedFiat
  } = useSelector((state) => state.user)
  const { showCashierPopup } = useSelector((state) => state?.settings)
  const dispatch = useDispatch()
  const [currentTab, setCurrentTab] = useState(null)
  // const [filteredWallet, setFilteredWallet] = useState(user?.wallets)
  // const [inputCurrency, setInputCurrency] = useState('')
  // const selectedFiatSymbol = user?.wallets?.find(
  //   (e) => e?.currency?.code === selectedFiat
  // )?.currency?.symbol
  const PRECISION_COUNT = 2

  // const handleChangeSelectedWallet = (wallet) => {
  //   dispatch(setSelectedWallet(wallet))
  //   dispatch(setPrimaryWallet({ walletId: wallet.id }))
  // }

  // const convertToFiat = async (wallet) => {
  //   cryptoToFiat(
  //     CRYPTO_COINS[wallet?.currency?.code],
  //     selectedFiat,
  //     Number(wallet.amount)
  //   )
  //     .then((res) => {
  //       setFilteredWallet((prevState) =>
  //         prevState.map((e) =>
  //           e?.currency?.code === wallet?.currency?.code
  //             ? { ...e, convertedValue: res || 0 }
  //             : e
  //         )
  //       )
  //     })
  //     .catch((e) => {
  //       setFilteredWallet((prevState) =>
  //         prevState.map((e) =>
  //           e?.currency?.code === wallet?.currency?.code
  //             ? { ...e, convertedValue: t('unableToConvert') }
  //             : e
  //         )
  //       )
  //     })
  // }

  // const updatePrice = async () => {
  //   const wallets = hideZeroCurrency
  //     ? user?.wallets?.filter((wallet) => wallet.amount > 0)
  //     : user?.wallets
  //   setFilteredWallet(
  //     inputCurrency?.length > 0
  //       ? wallets?.filter(wallet => (lowerCase(wallet.currency.code)?.includes(lowerCase(inputCurrency))))
  //           ?.map((wallet) => ({
  //             ...wallet,
  //             convertedValue: convertToFiat(wallet)
  //           }))
  //       : wallets?.map((wallet) => ({
  //         ...wallet,
  //         convertedValue: convertToFiat(wallet)
  //       }))
  //   )
  // }

  // useEffect(() => {
  //   if (user) {
  //     if (displayFiatCurrency) {
  //       updatePrice()
  //       const updateInterval = setInterval(() => {
  //         updatePrice()
  //       }, 10000)
  //       return () => clearInterval(updateInterval)
  //     }
  //     if (hideZeroCurrency) {
  //       setFilteredWallet(
  //         inputCurrency?.length > 0
  //           ? user?.wallets?.filter((wallet) => lowerCase(wallet?.currency?.code)
  //               ?.includes(lowerCase(inputCurrency)) && wallet?.amount > 0)
  //           : user?.wallets?.filter((wallet) => wallet?.amount > 0))
  //     } else {
  //       setFilteredWallet(
  //         inputCurrency?.length > 0
  //           ? user?.wallets?.filter((wallet) => (lowerCase(wallet?.currency?.code)
  //               ?.includes(lowerCase(inputCurrency))))
  //           : user?.wallets)
  //     }
  //   }
  // }, [displayFiatCurrency, selectedFiat, hideZeroCurrency, user, inputCurrency])

  return (
    <div className='search-filter-right d-flex align-items-center currency-dropdown-wrap'>
      <button
        className='btn btn-primary currencies-btn dropdown-toggle'
        type='button'
        id='currencies_dropdown_button'
        data-bs-toggle='dropdown'
        aria-expanded='false'
      >
        <div className='d-flex main-currency-wrapper'>
          {/* <span className='currency-main'> */}
          {/* <img className='me-1' src={clutchWalletIcon} /> */}
          {/* {selectedWallet?.currency?.code} */}
          {/* </span> */}
          <div className='currency-text'>
            {`${selectedWallet?.currency?.isFiat
              ? selectedWallet?.currency?.code
              : ''
              } ${selectedWallet ? parseFloat(getPrecision(parseFloat(selectedWallet?.amount), PRECISION_COUNT)?.toFixed(PRECISION_COUNT))?.toLocaleString('en-IE') : 'USD 0.00'}`}
          </div>
        </div>
      </button>
      <ul
        className='dropdown-menu provider-list currencies-options'
        aria-labelledby='currencies_dropdown'
        id='currencies_dropdown'
      >
        {/* <div className='provider-list-wrap'>
          <li>
            <div
              className='dropdown-item currency-img-header d-flex align-items-center justify-content-between non-cash-amount'
            >
              <div className='currency-unit'>{selectedWallet?.currency?.code} {parseFloat(getPrecision(parseFloat(selectedWallet?.nonCashAmount), PRECISION_COUNT)?.toFixed(PRECISION_COUNT))?.toLocaleString('en-IE')}</div>
              <div className='d-flex provider-list-right align-items-center'>
                <span>{t('nonCashAmount')}</span>
              </div>
            </div>
          </li>
        </div> */}

        <div className='provider-list-wrap'>
          <li>
            <div
              className='dropdown-item currency-img-header d-flex align-items-center justify-content-between cursor-pointer'
              onClick={() => {
                setCurrentTab(t('deposit'))
                dispatch(setShowCashierPopup(true))
              }}
            >
              <span>{t('deposit')}</span>
            </div>
          </li>
        </div>

        <div className='provider-list-wrap'>
          <li>
            <div
              className='dropdown-item currency-img-header d-flex align-items-center justify-content-between cursor-pointer'
              onClick={() => {
                setCurrentTab(t('withdraw'))
                dispatch(setShowCashierPopup(true))
              }}
            >
              <span>{t('withdraw')}</span>
            </div>
          </li>
        </div>
      </ul>
      {showCashierPopup && <CashierPopup currentTab={currentTab} setCurrentTab={setCurrentTab} />}
    </div>
  )
}

export default CurrencyDropdown
